import Vue from 'vue';
import * as types from './mutation-types'

const mutations = {
    [types.SET_SCANNER_PARAMS](state, params) {
        console.debug('set params', params);
        state.params = params;
    },
    [types.SET_FILTERS_FROM_URL](state, data) {
        state.urlFilters = data;
    },
    [types.SET_BOND_FIELDS_FROM_URL](state, data) {
        state.bondFields = data;
    }
}

export default mutations;